<template>
    <div>
        <h3 class="text-center"
            v-text="jsonObjectAboutHorses.alurebiInfo.alurebiName"></h3>
        <ul>
            <li v-for="info in jsonObjectAboutHorses.alurebiInfo.alurebi"
                v-html="info"></li>
        </ul>


        <h3 class="text-center"
            v-text="jsonObjectAboutHorses.poniArtInfo.poniArtName"></h3>
        <ul>
            <li v-for="info in jsonObjectAboutHorses.poniArtInfo.poniArt"
                v-html="info"></li>
        </ul>

        
        <h3 class="text-center"
            v-text="jsonObjectAboutHorses.seatArtInfo.seatArtName"></h3>
        <ul>
            <li v-for="info in jsonObjectAboutHorses.seatArtInfo.seatArt"
                v-html="info"></li>
        </ul>


        <h3 class="text-center"
            v-text="jsonObjectAboutHorses.matchArtInfo.matchArtName"></h3>
        <ul>
            <li v-for="info in jsonObjectAboutHorses.matchArtInfo.matchArt"
                v-html="info"></li>
        </ul>


        <h3 class="text-center"
            v-text="jsonObjectAboutHorses.chortArtInfo.chortArtName"></h3>
        <ul>
            <li v-for="info in jsonObjectAboutHorses.chortArtInfo.chortArt"
                v-html="info"></li>
        </ul>

        <!--  -->
        <h3 class="text-center"
            v-text="jsonObjectAboutHorses.horseColorInfo.horseColorName"></h3>
        <ul>
            <li v-for="info in jsonObjectAboutHorses.horseColorInfo.horseColor"
                v-html="info"></li>
        </ul>


        <!--  -->
        <h3 class="text-center"
            v-text="jsonObjectAboutHorses.geoHorseGameInfo.geoHorseGameName"></h3>
        <ul>
            <li v-for="info in jsonObjectAboutHorses.geoHorseGameInfo.geoHorseGame"
                v-html="info"></li>
        </ul>


        <!--  -->
        <h3 class="text-center"
            v-text="jsonObjectAboutHorses.horseManejInfo.horseManejName"></h3>
        <ul>
            <li v-for="info in jsonObjectAboutHorses.horseManejInfo.horseManej"
                v-html="info"></li>
        </ul>
    </div>
</template>

<script>
import jsonObjectAboutHorses from './AboutHorsesJSON/en-AboutHorses.json';
export default {
 data(){
     return{
         jsonObjectAboutHorses,
     }
 }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/EN-vers/menu/AbautHorses.vue